export default __webpack_public_path__ + "static/media/6.31775622.png";